import { Icon } from "@mdi/react";
import React from "react";

import { mdiAlertCircle } from "@mdi/js";
import { Modal } from "antd";

import styles from "./UnsavedChangesModal.module.scss";

interface UnsavedChangesModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  containerRef: React.RefObject<HTMLDivElement>;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isVisible,
  onConfirm,
  onCancel,
  containerRef
}) => {
  const container = containerRef?.current;

  return (
    <Modal
      title={
        <div className={styles.headerContainer}>
          <Icon path={mdiAlertCircle} size={"18px"} /> Unsaved Changes
        </div>
      }
      getContainer={container ? () => container : false}
      open={isVisible}
      onOk={onConfirm}
      onCancel={onCancel}
      className={styles.unsavedChangesModal}
      style={{ top: "15%" }}>
      You have unsaved changes. Proceed without saving?
    </Modal>
  );
};
